module.exports = __webpack_public_path__ + "static/img/default1.5873c5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/default1.png
// module id = E+AF
// module chunks = 3